/* ══════════════════════════════════════════════════════════════════
   购物车抽屉。**EB.overlay 的调用方**，不自己写浮层。

   滚动锁、焦点陷阱、遮罩、Esc 关闭、同一时间只允许一个浮层 —— 全在 EB.overlay 里，
   这里只登记一个 id，然后管自己的业务：改数量、删行、开关包裹保障、重新渲染。

   重新渲染走 **Cart AJAX API 的 sections 参数**：
   `/cart/change.js` 直接把渲染好的 section HTML 一起返回，
   不用「先改购物车、再单独取一次页面」两个来回。
   ══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var SECTION_ID = 'cart-drawer';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var drawer = null;
  var releaseFocus = null;
  var busy = false;

  function el(sel, ctx) { return (ctx || document).querySelector(sel); }

  /* ── 登记到 EB.overlay ── */
  function register() {
    if (!window.EB || !EB.overlay) return;
    EB.overlay.register(SECTION_ID, {
      onOpen: function () {
        drawer = el('[data-cart-drawer]');
        if (!drawer) return;
        drawer.hidden = false;
        window.requestAnimationFrame(function () { drawer.classList.add('is-open'); });
        releaseFocus = EB.trapFocus(el('.eb-cart__panel', drawer));
      },
      onClose: function () {
        if (!drawer) return;
        drawer.classList.remove('is-open');
        if (releaseFocus) releaseFocus();
        /* 等推出动画走完再 hidden，否则它会瞬间消失而不是滑出去 */
        window.setTimeout(function () {
          if (!drawer.classList.contains('is-open')) drawer.hidden = true;
        }, 420);
      }
    });
  }

  function open() {
    if (window.EB && EB.overlay) EB.overlay.open(SECTION_ID);
  }
  function close() {
    if (window.EB && EB.overlay) EB.overlay.close(SECTION_ID);
  }

  /* ── 用返回的 section HTML 换掉抽屉内容 ── */
  function render(html) {
    var next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-drawer]');
    var current = el('[data-cart-drawer]');
    if (!next || !current) return;
    var wasOpen = current.classList.contains('is-open');
    current.innerHTML = next.innerHTML;
    if (wasOpen) current.classList.add('is-open');
    drawer = current;
    if (window.EB && EB.motion) EB.motion.mount(current);
  }

  function updateCount(count) {
    document.querySelectorAll('[data-eb-cart-count]').forEach(function (b) {
      b.textContent = count;
      b.hidden = count === 0;
    });
  }

  /* ── 改数量 / 删除 / 加保障 ──
     任何一次改动都用同一个入口，返回的 section HTML 直接换上去。 */
  function change(body) {
    if (busy) return;
    busy = true;
    var panel = el('.eb-cart__panel');
    if (panel) panel.classList.add('is-busy');

    body.sections = SECTION_ID;
    body.sections_url = window.location.pathname;

    var action = body.updates ? 'update' : (body.id && body.quantity === undefined ? 'add' : 'change');
    return fetch(root + 'cart/' + action + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.sections && data.sections[SECTION_ID]) render(data.sections[SECTION_ID]);
        if (typeof data.item_count === 'number') updateCount(data.item_count);
        if (window.EB) EB.emit('cart:changed', { cart: data });
      })
      .catch(function () { window.location.href = root + 'cart'; })
      .finally(function () {
        busy = false;
        var p = el('.eb-cart__panel');
        if (p) p.classList.remove('is-busy');
      });
  }

  /* 卡片和搭配 section 加购完只会喊一声 cart:updated，
     由抽屉自己去取最新的 HTML —— 它们不需要知道抽屉长什么样。 */
  function refresh() {
    return fetch(window.location.pathname + '?section_id=' + SECTION_ID)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        render(html);
        var count = el('[data-cart-drawer] .eb-cart__count');
        var n = count ? parseInt(count.textContent.replace(/\D/g, ''), 10) : null;
        if (!isNaN(n) && n !== null) updateCount(n);
      });
  }

  /* ── 事件 ── */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-eb-cart-open]');
    if (opener) {
      /* 后台设成「跳转购物车页」时不接管，让链接照常走 */
      if (document.documentElement.dataset.cartBehavior === 'page') return;
      if (!el('[data-cart-drawer]')) return;
      e.preventDefault();
      open();
      return;
    }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); close(); return; }

    var qty = e.target.closest('[data-qty]');
    if (qty) {
      e.preventDefault();
      var line = qty.closest('[data-line]');
      if (!line) return;
      var delta = parseInt(qty.dataset.qty, 10);
      var current = parseInt(el('[data-qty-value]', line).textContent, 10) || 1;
      var target = delta === 0 ? 0 : current + delta;
      /* 车下面挂着跟车买的延保：数量一起改，一台车一份。一次 update 请求改完，
         不分两次 —— 中间那一刻购物车里是两台车一份延保。 */
      var kids = drawer ? drawer.querySelectorAll('[data-parent-key="' + line.dataset.lineKey + '"]') : [];
      if (kids.length) {
        var updates = {};
        updates[line.dataset.lineKey] = target;
        kids.forEach(function (k) { updates[k.dataset.lineKey] = target; });
        change({ updates: updates });
      } else {
        change({ id: line.dataset.lineKey, quantity: target });
      }
      return;
    }

    var prot = e.target.closest('[data-protection]');
    if (prot) {
      e.preventDefault();
      var on = prot.getAttribute('aria-checked') === 'true';
      if (on) change({ id: prot.dataset.protectionKey, quantity: 0 });
      else change({ id: parseInt(prot.dataset.protection, 10), quantity: 1 });
    }
  });

  /* 订单备注：停手 600ms 再提交，不是每敲一个字发一次 */
  document.addEventListener('input', function (e) {
    if (!e.target.matches('[data-cart-note]')) return;
    if (!window.EB || !EB.debounce) return;
    if (!e.target.dataset.bound) {
      e.target.dataset.bound = '1';
      e.target.addEventListener('input', EB.debounce(function () {
        fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: e.target.value })
        });
      }, 600));
    }
  });

  function mount() {
    register();
    drawer = el('[data-cart-drawer]');
    if (window.EB && EB.on) {
      /* 卡片 / 搭配 section 加购完喊一声，这里刷新并打开 */
      EB.on('cart:updated', function () { refresh().then(open); });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
  else mount();
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('[data-cart-drawer]')) mount();
  });
})();
